import { Region } from '@hiwaldo/sdk';

export const currentRegion = (): Region =>
  (process.env.REGION as Region) ||
  (process.env.NEXT_PUBLIC_REGION as Region) ||
  Region.US;
